/**
 * Get keys from an object to loop through and keep type information.
 * Do `getObjectKeys(object)` instead of `Object.keys(object)`
 * See https://stackoverflow.com/a/59459000/957794
 */

// TODO: This isn't a type, its a utility, so it does not belong in this folder.
// But also, this utility shouldn't be necessary. You can just pass a generic
// to `Object.keys`. Remove this when ready.
export const getObjectKeys = Object.keys as <T extends Record<keyof T, unknown>>(obj: T) => Array<keyof T>;

// TODO: This appears to be the better way of retaining key typing.
export const getTypedObjectKeys = Object.keys as <T extends object>(obj: T) => Array<keyof T>;
